export const PRODUCTION_APP_URL = "https://app.robotrock.io";
export const DEV_APP_URL = "http://localhost:4004";
export const PRODUCTION_API_URL = "https://api.robotrock.io/v1";
export const DEV_API_URL = "http://localhost:4001/v1";
export const DEV_DOCS_URL = "http://localhost:4002";

/** Local dev server ports for all RobotRock apps (4000–4008). */
export const DEV_PORTS = {
  marketing: 4000,
  api: 4001,
  docs: 4002,
  status: 4003,
  app: 4004,
  admin: 4005,
  triggerTest: 4006,
  workflowTest: 4007,
  mcp: 4008,
} as const;

/** Production signup URL (stable constant for tests and production defaults). */
export const APP_SIGNUP_URL = `${PRODUCTION_APP_URL}/sign-up`;

function readExplicitAppUrl(): string | undefined {
  const url =
    process.env.NEXT_PUBLIC_APP_URL?.trim() ||
    process.env.NEXT_PUBLIC_APP_PREVIEW_URL?.trim();
  return url ? url.replace(/\/$/, "") : undefined;
}

/** Dashboard origin — localhost:4004 in dev unless overridden via env. */
export function getAppBaseUrl(): string {
  const explicit = readExplicitAppUrl();
  if (explicit) return explicit;
  if (process.env.NODE_ENV === "development") {
    return DEV_APP_URL;
  }
  return PRODUCTION_APP_URL;
}

export function getAppSignupBaseUrl(): string {
  return `${getAppBaseUrl()}/sign-up`;
}

/** Ensure the RobotRock API base URL ends with `/v1` (no trailing slash). */
export function normalizeRobotRockApiBaseUrl(baseUrl: string): string {
  const trimmed = baseUrl.trim().replace(/\/+$/, "");
  if (trimmed.endsWith("/v1")) {
    return trimmed;
  }
  return `${trimmed}/v1`;
}

/**
 * RobotRock API origin for SDK / agent hooks.
 * Local dev defaults to `http://localhost:4001/v1` unless overridden.
 */
export function getRobotRockApiBaseUrl(): string {
  const explicit =
    process.env.ROBOTROCK_BASE_URL?.trim() ||
    process.env.ROBOTROCK_API_URL?.trim();
  if (explicit) {
    return normalizeRobotRockApiBaseUrl(explicit);
  }
  if (process.env.NODE_ENV === "production") {
    return PRODUCTION_API_URL;
  }
  return DEV_API_URL;
}
